import { observer } from 'mobx-react'
import React, { Component, Fragment } from 'react'
import BigImage from '../../components/BigImage'
import Paginate from '../../components/Paginate'
import Paragraph from '../../components/Paragraph'
import Prompts from '../../components/Prompts'
import patient from '../../stores/patient'

@observer
export default class Session3 extends Component {
  render() {
    return (
      <Fragment>
        <BigImage src="/images/gardening.jpg" />
        <Prompts>
          <Prompts.Q str="prose.itsGreatToSeeYou" />
          <Prompts.R str="prose.itSoundsLike" />
          <Prompts.S>
            <Paragraph str="prose.chooseWhichParts" />
            <Paragraph str="prose.lastTimeWeMet" />
          </Prompts.S>
          <Prompts.Q str="prose.tellMeHowItsGone" />
          <Prompts.R str="prose.youHave" />
          <Prompts.P>
            {patient.fields.lowVision==="YES"?<Paragraph str="prose.weKnowRepetitionLowVision" />:<Paragraph str="prose.weKnowRepetition" />}
            <Paragraph str="prose.ifParticipantSaysNo" />
          </Prompts.P>
          <Prompts.Q str="prose.canYouPick" />
          <Prompts.R str="prose.itSoundsLikeBlankMostHelpful" />
        </Prompts>
        <Paginate>
          <Paginate.Button
            color="blue"
            str="titles.learn"
            to={`/learn/third/${patient.fields._id}`}
          />
          <Paginate.Button
            color="red"
            str="titles.goal"
            to={`/goal/third/${patient.fields._id}`}
          />
        </Paginate>
      </Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/SessionIntro/Session3.js